import React from 'react';
import { Grid } from '@mui/material';
import { keyframes } from '@mui/system';

const slideInCloudLeft = keyframes`
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
`;

const slideInCloudRight = keyframes`
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
`;

const slideInMountain = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateX(0);
  }
`;

function SplashScreen() {
  return (
    <>
      <Grid
        top="38%"
        bottom="25%"
        position="absolute"
        left={0}
        sx={{ animation: `${slideInCloudLeft} 0.8s ease forwards` }}
      >
        <img src="/assets/icons/cloud-left-white.svg" alt="cloud-left-white" />
      </Grid>
      <Grid
        top="29%"
        bottom="35%"
        position="absolute"
        left={0}
        sx={{ animation: `${slideInCloudLeft} 0.8s ease forwards` }}
      >
        <img src="/assets/icons/cloud-left.svg" alt="cloud-left" />
      </Grid>
      <Grid
        top="22%"
        bottom="45%"
        position="absolute"
        right={0}
        sx={{ animation: `${slideInCloudRight} 0.8s ease forwards` }}
      >
        <img src="/assets/icons/cloud-right-white.svg" alt="cloud-right-white" />
      </Grid>
      <Grid
        top="7%"
        bottom="59%"
        position="absolute"
        right={0}
        sx={{ animation: `${slideInCloudRight} 0.8s ease forwards` }}
      >
        <img src="/assets/icons/cloud-right.svg" alt="cloud-right" />
      </Grid>
      <Grid
        position="absolute"
        bottom="-4px"
        width="100%"
        sx={{ animation: `${slideInMountain} 0.8s ease forwards` }}
      >
        <img src="/assets/icons/mountain-1.svg" alt="mountain-1" width="100%" />
      </Grid>
      <Grid
        position="absolute"
        bottom="-4px"
        width="100%"
        sx={{ animation: `${slideInMountain} 0.8s ease forwards` }}
      >
        <img src="/assets/icons/mountain-2.svg" alt="mountain-2" width="100%" />
      </Grid>
      <Grid
        position="absolute"
        bottom="-4px"
        width="100%"
        sx={{ animation: `${slideInMountain} 0.8s ease forwards` }}
      >
        <img src="/assets/icons/mountain-3.svg" alt="mountain-3" width="100%" height="100%" />
      </Grid>
    </>
  );
}

export default SplashScreen;
